//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { downloadFileZipIos, downloadZipDesktop } from "@/assets/js/appFunc";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import Documents from "../../../components/Flow/documents.vue";

export default {
    name: "QfMAppDocuments",
    components: { Documents, AQModal },
    props: {
        actionsList: Array,
        processInstance: String,
        applicationId: String,
        isSmallScreen: { type: Boolean, default: false }
    },
    data() {
        return {
            localShow: true,
            comment: null,
            submitAction: null,
            cancel: { label: "Close" },
            headerActions: [{
                label: this.$t("documents.download"),
                itemDisabled: this.optionDisabled
            }],
            titleModal: this.$t("documents.titleModal"),
            hasCancelDownloadBtns: false,
            hasCheckbox: false,
            documentsToDownload: [],
            resetCheckbox: false,
            optionDisabled: false,
            longTouchModel: null,
            hideClose: false,
            cancelBtn: null,
            downloadBtn: null
        };
    },
    computed: {
        documentsProps() {
            return {
                processInstance: this.processInstance,
                hasCheckbox: this.hasCheckbox,
                resetCheckbox: this.resetCheckbox,
                applicationId: this.applicationId
            };
        }
    },
    methods: {
        ...mapActions("admin", ["downloadAllDocs"]),
        modalAction(action) {
            if (action === "secondary") {
                this.backtoDefault();
            } else if (action === this.$t("documents.download")) {
                this.headerActions = [];
                this.titleModal = "";
                this.cancelBtn = { label: this.$t("generic.cancel") };
                this.downloadBtn = { label: this.$t("documents.download"), disabled: true };
                this.hasCheckbox = true;
                this.hideClose = true;
                this.resetCheckbox = true;
            } else if (action === "primary") {
                this.downloadAllDocs(this.documentsToDownload).then(data => {
                    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                        downloadFileZipIos("application/zip", data.data);
                    } else {
                        downloadZipDesktop("application/zip", data);
                    }
                });
                this.backtoDefault();
            } else if (action === "close") {
                this.localShow = false;
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        downloadDocs(value) {
            this.documentsToDownload = value;
            this.downloadBtn.disabled = !this.documentsToDownload.length;
        },
        sendDataModal(value) {
            if (value) {
                this.longTouchModel = this.headerActions;
            }
        },
        backtoDefault() {
            this.headerActions = [{
                label: this.$t("documents.download"),
                itemDisabled: this.optionDisabled
            }];
            this.titleModal = this.$t("documents.titleModal");
            this.cancelBtn = null;
            this.downloadBtn = null;
            this.hasCheckbox = false;
            this.hideClose = false;
            this.resetCheckbox = false;
            this.downloadBtn.disabled = true;
            this.longTouchModel = [];
        },
        disableOption(val) {
            this.optionDisabled = val;
            this.headerActions[0].itemDisabled = val;
        }
    }
};
